import { useState } from "react";
import { Container, Card, Form, Button, Spinner } from "react-bootstrap";
import API from "../services/api";
import { useNavigate } from "react-router-dom";

const EnterCode = () => {
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async () => {
    if (!code.trim()) {
      setError("Please enter exam code");
      return;
    }
  
    setLoading(true);
    setError("");
  
    try {
      const fd = new FormData();
      fd.append("session_id", localStorage.getItem("session_id"));
      fd.append("code", code);
  
      const res = await API.post("/auth/validate-code.php", fd);
  
      if (res.data.status === "success") {
  
        // 🔥 CLEAR PREVIOUS EXAM DATA
        localStorage.removeItem("exam_answers");
        localStorage.removeItem("exam_submitted");
        localStorage.removeItem("exam_start_time");
        localStorage.removeItem("exam_review"); 
localStorage.removeItem("exam_current");  
  
        localStorage.setItem("paper_id", res.data.paper_id);
        localStorage.setItem("exam_code", code);
  
        // fullscreen
        const el = document.documentElement;
        if (el.requestFullscreen) {
          el.requestFullscreen().catch(() => {});
        }
  
        navigate("/exam");
  
      } else {
        const msg = res.data.msg || "Invalid exam code";
      
        // 🚨 if already attempted → redirect
        if (msg.toLowerCase().includes("already attempted")) {
          navigate("/dashboard", { state: { message: msg } });
          return;
        }
      
        setError(msg);
      }
    } catch (err) {
      setError("Something went wrong. Try again.");
    }
  
    setLoading(false);
  };

  return (
    <div
      style={{
        minHeight: "90vh",
        background: "#f5f7fa",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}
    >
      <Container>
        <Card
          className="mx-auto shadow"
          style={{
            maxWidth: "500px",
            borderRadius: "12px",
            border: "none"
          }}
        >
          <Card.Body className="p-4">

            {/* HEADER */}
            <div className="text-center mb-4">
              <h4 className="fw-bold">Online Assessment Portal</h4>
              <p className="text-muted small">
                Enter your exam code to begin the assessment
              </p>
            </div>

            {/* INPUT */}
            <Form.Group className="mb-3">
              <Form.Label className="fw-medium">
                Exam Code
              </Form.Label>

              <Form.Control
                type="text"
                placeholder="Enter your exam code"
                value={code}
                onChange={(e) => setCode(e.target.value)}
                style={{
                  height: "48px",
                  borderRadius: "8px"
                }}
              />
            </Form.Group>

            {/* ERROR */}
            {error && (
              <div className="text-danger mb-3 small">
                {error}
              </div>
            )}

            {/* BUTTON */}
            <Button
              variant="primary"
              className="w-100"
              style={{
                height: "48px",
                borderRadius: "8px",
                fontWeight: "500"
              }}
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? (
                <Spinner size="sm" />
              ) : (
                "Start Exam"
              )}
            </Button>

            {/* INSTRUCTIONS */}
            <div className="mt-4">
              <h6 className="fw-bold">Instructions</h6>
              <ul className="text-muted small ps-3 mb-0">
                <li>Ensure stable internet connection</li>
                <li>Do not refresh during the exam</li>
                <li>Exam will auto-submit on timeout</li>
                <li>Multiple attempts are not allowed</li>
              </ul>
            </div>

          </Card.Body>
        </Card>
      </Container>
    </div>
  );
};

export default EnterCode;